var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSpotRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.625 11.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zm14.625 0C23.25 5.413 18.212.375 12 .375S.75 5.413.75 11.625c0 7.875 11.25 18 11.25 18s11.25-10.125 11.25-18z",
    fill: "#CE2B18"
  })));
}

export default SvgIconSpotRed;